import React from 'react';
import { Card, Spinner, Form } from 'react-bootstrap';
import { Settings as SettingsIcon } from 'lucide-react';
import { useUserWorkspaceSettings } from '../../hooks/useUserWorkspaceSettings';

const WorkspaceSettings = ({ token, workspaceId: propWorkspaceId }) => {
    const workspaceId = propWorkspaceId || localStorage.getItem("workspaceId");

    const { settings: wsSettings, updateSetting: updateWsSetting, loading: wsSettingsLoading } = useUserWorkspaceSettings({
        token,
        workspaceId
    });

    if (!workspaceId) return null;

    return (
        <Card className="shadow-sm border-0 mb-4">
            <Card.Header className="bg-white py-3 border-bottom">
                <h5 className="mb-0 d-flex align-items-center">
                    <SettingsIcon size={20} className="me-2 text-primary" /> Workspace Settings
                </h5>
            </Card.Header>
            <Card.Body>
                {wsSettingsLoading ? (
                    <div className="text-center"><Spinner size="sm" /></div>
                ) : (
                    <div>
                        <Form.Check
                            type="switch"
                            id="enable-event-completion"
                            label="Event Completion (Events as Tasks)"
                            checked={wsSettings?.enableEventCompletion || false}
                            onChange={(e) => updateWsSetting('enableEventCompletion', e.target.checked)}
                        />
                        <div className="form-text small mt-1">
                            Allows marking calendar events as done.
                        </div>
                    </div>
                )}
            </Card.Body>
        </Card>
    );
};

export default WorkspaceSettings;
